import React from "react";
import { Section } from "../ui/Section";
import { Field } from "../ui/Field";
import { ArmaSearchSelect } from "../../components/ArmaSearchSelect";
import styles from "../../styles/evento-form.module.css";
import EnlacesField from "../../../../components/EnlacesField";

import { isDateInRange, isImage, isPdf, isExcel, sortPersonasByNombre } from "../../domain/eventoUtils";

export function StepCacerias({
    form,
    notice,
    setNotice,

    // catálogos
    roles,
    tiposCaceria,
    personas,

    // lookups / helpers
    getRolNameById,
    personasDisponiblesEnCaceria,
    armasIndex,

    // accordion
    isCaceriaOpen,
    toggleCaceria,
    setOpenCacerias,

    // form actions
    addItem,
    removeItem,
    updateArray,
    setForm,

    // ficheros
    filesCaceria,
    handleCaceriaFileChange,
    clearRutaDoc,
    deleteRutaDocServer,

    // duplicado
    duplicateCaceria,
}) {
    return (
        <Section
            title="Cacerías"
            aside={
                <div className={styles["actions-row"]}>
                    <button
                        className={`${styles.btn} ${styles.primary}`}
                        type="button"
                        onClick={() => {
                            addItem("cacerias", {
                                fecha: "",
                                nombre: "",
                                rutaDocumento: "",
                                enlaces: [],
                                tipoCaceria: "",
                                participaciones: [],
                            });
                            const newIdx = form.cacerias.length;
                            setOpenCacerias((s) => new Set([...s, newIdx]));
                        }}
                    >
                        + Añadir
                    </button>
                </ div>
            }
        >
            {form.cacerias.map((c, cIdx) => {
                const open = isCaceriaOpen(cIdx);
                const total = (c.participaciones || []).length || 0;
                const resumen = `${c.fecha || "Sin fecha"} • ${c.tipoCaceria || "Sin tipo"} • ${total} participante(s)`;
                const tituloCaceria = c.nombre ? c.nombre : `Cacería ${cIdx + 1}`;

                return (
                    <div
                        key={`cac-${cIdx}`}
                        className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}
                    >
                        <button
                            type="button"
                            className={styles["accordion-header"]}
                            onClick={() => toggleCaceria(cIdx)}
                            aria-expanded={open}
                            aria-controls={`cac-body-${cIdx}`}
                        >
                            <div className={styles["accordion-title"]}>
                                <strong>{tituloCaceria}</strong>
                                <span className={styles.muted}>— {resumen}</span>
                            </div>
                            <span className={styles.chevron} aria-hidden>
                                ▾
                            </span>
                        </button>

                        <div id={`cac-body-${cIdx}`} className={styles["accordion-body"]}>
                            <div className={styles["item-row"]}>
                                <Field label="Nombre (opcional)">
                                    <input
                                        type="text"
                                        placeholder="Ej: Montería La Dehesa"
                                        value={c.nombre || ""}
                                        onChange={(e) => updateArray("cacerias", cIdx, "nombre", e.target.value)}
                                    />
                                </Field>

                                <div className={styles["grid-3"]}>
                                    <Field label="Fecha">
                                        <input
                                            type="date"
                                            value={c.fecha}
                                            min={form.fechaInicio || undefined}
                                            max={form.fechaFin || undefined}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (!isDateInRange(val, form.fechaInicio, form.fechaFin)) {
                                                    setNotice(
                                                        "La fecha de la cacería debe estar entre la fecha de inicio y fin del evento."
                                                    );
                                                    return;
                                                }
                                                setNotice("");
                                                updateArray("cacerias", cIdx, "fecha", val);
                                            }}
                                        />
                                    </Field>

                                    <Field label="Tipo de cacería">
                                        <select
                                            value={c.tipoCaceria}
                                            onChange={(e) => updateArray("cacerias", cIdx, "tipoCaceria", e.target.value)}
                                        >
                                            <option value="">Selecciona tipo</option>
                                            {tiposCaceria.map((t) => (
                                                <option key={t.codigo} value={t.codigo}>
                                                    {t.descripcion}
                                                </option>
                                            ))}
                                        </select>
                                    </Field>

                                    <Field label="Documento (PDF/Imagen/Excel/CSV)">
                                        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                                            <input
                                                type="file"
                                                accept="
                          image/*,
                          application/pdf,
                          application/vnd.ms-excel,
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          text/csv
                        "
                                                onChange={(e) =>
                                                    handleCaceriaFileChange(cIdx, e.target.files?.[0] ?? null)
                                                }
                                            />

                                            {form.cacerias[cIdx]?.rutaDocumento && (
                                                <>
                                                    <button
                                                        type="button"
                                                        className={`${styles.btn} ${styles.ghost}`}
                                                        onClick={() => clearRutaDoc(cIdx)}
                                                        title="Quitar del formulario (no borra del servidor)"
                                                    >
                                                        Quitar del formulario
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={`${styles.btn} ${styles.danger}`}
                                                        onClick={() => deleteRutaDocServer(cIdx)}
                                                        title="Borrar en servidor"
                                                    >
                                                        Borrar en servidor
                                                    </button>
                                                </>
                                            )}
                                        </div>

                                        {form.cacerias[cIdx]?.rutaDocumento && (
                                            <div className={styles["file-preview"]} style={{ marginTop: 8 }}>
                                                {isImage(form.cacerias[cIdx].rutaDocumento) ? (
                                                    <img
                                                        src={form.cacerias[cIdx].rutaDocumento}
                                                        alt="Documento"
                                                        style={{ maxWidth: 160, borderRadius: 6, display: "block" }}
                                                    />
                                                ) : (
                                                    <a href={form.cacerias[cIdx].rutaDocumento} target="_blank" rel="noreferrer">
                                                        {isPdf(form.cacerias[cIdx].rutaDocumento) && "Ver PDF actual"}
                                                        {isExcel(form.cacerias[cIdx].rutaDocumento) && "Abrir Excel/CSV"}
                                                        {!isPdf(form.cacerias[cIdx].rutaDocumento) &&
                                                            !isExcel(form.cacerias[cIdx].rutaDocumento) &&
                                                            "Abrir documento"}
                                                    </a>
                                                )}
                                            </div>
                                        )}

                                        {filesCaceria[cIdx] && isImage(filesCaceria[cIdx]?.name || "") && (
                                            <div style={{ marginTop: 8 }}>
                                                <img
                                                    src={URL.createObjectURL(filesCaceria[cIdx])}
                                                    alt="Preview local"
                                                    style={{ maxWidth: 160, borderRadius: 6 }}
                                                    onLoad={(e) => URL.revokeObjectURL(e.currentTarget.src)}
                                                />
                                            </div>
                                        )}

                                        <EnlacesField
                                            value={c.enlaces}
                                            onChange={(enlaces) => updateArray("cacerias", cIdx, "enlaces", enlaces)}
                                            buttonClassName={`${styles.btn} ${styles.ghost}`}
                                            dangerButtonClassName={`${styles.btn} ${styles.danger}`}
                                        />
                                    </Field>
                                </div>

                                <div className={styles.subhead}>
                                    <div>
                                        <h4>Participaciones</h4>
                                        <p className={styles.hint}>Solo personas añadidas en “Participantes”.</p>
                                    </div>


                                </div>

                                <div className={styles.tableDesktop}>
                                    <div className={styles["table-wrap"]}>
                                        <table className={styles["participaciones-table"]}>
                                            <thead>
                                                <tr>
                                                    <th>Rol</th>
                                                    <th>Persona</th>
                                                    <th>Arma1 (opcional)</th>
                                                    <th>Arma2 (opcional)</th>
                                                    <th>Secretario</th>
                                                    <th>Cargador</th>
                                                    <th></th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {(c.participaciones || []).length === 0 && (
                                                    <tr>
                                                        <td colSpan={7} className={styles.hint}>
                                                            Aún no hay participantes en esta cacería.
                                                        </td>
                                                    </tr>
                                                )}

                                                {(c.participaciones || []).map((p, pIdx) => {
                                                    const personasDisponibles = personasDisponiblesEnCaceria(p.rolId, p.personaId);
                                                    const esCazador = getRolNameById(p.rolId) === "CAZADOR";

                                                    return (
                                                        <tr key={`t-c${cIdx}-p${pIdx}`}>
                                                            <td>
                                                                <select
                                                                    className={styles.select_rol}
                                                                    value={p.rolId}
                                                                    onChange={(e) => {
                                                                        const newRolId = Number(e.target.value) || "";
                                                                        const updated = [...form.cacerias];
                                                                        const row = { ...updated[cIdx].participaciones[pIdx] };
                                                                        row.rolId = newRolId;

                                                                        const nowCaz = getRolNameById(newRolId) === "CAZADOR";
                                                                        if (!nowCaz) { row.secretarioId = ""; row.cargadorId = ""; }

                                                                        const rolName = getRolNameById(newRolId);
                                                                        const per = personas.find((x) => Number(x.id) === Number(row.personaId));
                                                                        const okPersona =
                                                                            rolName === "CAZADOR"
                                                                                ? per?.tipoPersona === "CLIENTE"
                                                                                : rolName === "SECRETARIO" || rolName === "CARGADOR"
                                                                                    ? per?.tipoPersona === "STAFF"
                                                                                    : true;
                                                                        if (!okPersona) row.personaId = "";

                                                                        updated[cIdx].participaciones[pIdx] = row;
                                                                        setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                    }}
                                                                >
                                                                    <option value="">Seleccione</option>
                                                                    {roles.map((r) => (
                                                                        <option key={r.id} value={r.id}>{r.rol}</option>
                                                                    ))}
                                                                </select>
                                                            </td>

                                                            <td>
                                                                <select
                                                                    value={p.personaId}
                                                                    onChange={(e) => {
                                                                        const updated = [...form.cacerias];
                                                                        updated[cIdx].participaciones[pIdx].personaId = Number(e.target.value) || "";
                                                                        setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                    }}
                                                                >
                                                                    <option value="">Seleccione</option>
                                                                    {personasDisponibles.map((pers) => (
                                                                        <option key={pers.id} value={pers.id}>
                                                                            {pers.nombre} {pers.apellidos}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>

                                                            <td><div className={styles.armaField}><ArmaSearchSelect armas={armasIndex} valueId={p.arma1Id || ""} onChange={(newId) => {
                                                                const updated = [...form.cacerias];
                                                                updated[cIdx].participaciones[pIdx].arma1Id = newId || "";
                                                                setForm((prev) => ({ ...prev, cacerias: updated }));
                                                            }} /></div></td>

                                                            <td><div className={styles.armaField}><ArmaSearchSelect armas={armasIndex} valueId={p.arma2Id || ""} onChange={(newId) => {
                                                                const updated = [...form.cacerias];
                                                                updated[cIdx].participaciones[pIdx].arma2Id = newId || "";
                                                                setForm((prev) => ({ ...prev, cacerias: updated }));
                                                            }} /></div></td>

                                                            <td>
                                                                {esCazador ? (
                                                                    <select
                                                                        className={styles.select_secretario}
                                                                        value={p.secretarioId || ""}
                                                                        onChange={(e) => {
                                                                            const updated = [...form.cacerias];
                                                                            updated[cIdx].participaciones[pIdx].secretarioId = Number(e.target.value) || "";
                                                                            setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                        }}
                                                                    >
                                                                        <option value="">Selecciona secretario</option>
                                                                        {sortPersonasByNombre(personas.filter((per) => per.tipoPersona === "STAFF")).map((per) => (
                                                                            <option key={per.id} value={per.id}>
                                                                                {per.nickname ? per.nickname : `${per.nombre} ${per.apellidos}`}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <span className={styles.muted}>—</span>
                                                                )}
                                                            </td>

                                                            <td>
                                                                {esCazador ? (
                                                                    <select
                                                                        className={styles.select_cargador}
                                                                        value={p.cargadorId || ""}
                                                                        onChange={(e) => {
                                                                            const updated = [...form.cacerias];
                                                                            updated[cIdx].participaciones[pIdx].cargadorId = Number(e.target.value) || "";
                                                                            setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                        }}
                                                                    >
                                                                        <option value="">Selecciona cargador</option>
                                                                        {sortPersonasByNombre(personas.filter((per) => per.tipoPersona === "STAFF")).map((per) => (
                                                                            <option key={per.id} value={per.id}>
                                                                                {per.nickname ? per.nickname : `${per.nombre} ${per.apellidos}`}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <span className={styles.muted}>—</span>
                                                                )}
                                                            </td>

                                                            <td className={styles["text-right"]}>
                                                                <button
                                                                    className={`${styles.btn} ${styles.danger}`}
                                                                    type="button"
                                                                    onClick={() => {
                                                                        const updated = [...form.cacerias];
                                                                        updated[cIdx].participaciones.splice(pIdx, 1);
                                                                        setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                    }}
                                                                >
                                                                    Eliminar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* TABLET/MÓVIL: cards verticales */}
                                <div className={styles.cardsMobile}>
                                    {(c.participaciones || []).length === 0 ? (
                                        <div className={styles.hint}>Aún no hay participantes en esta cacería.</div>
                                    ) : (
                                        <div className={styles.cardsList}>
                                            {(c.participaciones || []).map((p, pIdx) => {
                                                const personasDisponibles = personasDisponiblesEnCaceria(p.rolId, p.personaId);
                                                const esCazador = getRolNameById(p.rolId) === "CAZADOR";

                                                return (
                                                    <div key={`m-c${cIdx}-p${pIdx}`} className={styles.partCard}>
                                                        <div className={styles.partGrid}>
                                                            <div className={styles.partField}>
                                                                <div className={styles.partLabel}>Rol</div>
                                                                <select
                                                                    value={p.rolId}
                                                                    onChange={(e) => {
                                                                        const newRolId = Number(e.target.value) || "";
                                                                        const updated = [...form.cacerias];
                                                                        const row = { ...updated[cIdx].participaciones[pIdx] };
                                                                        row.rolId = newRolId;

                                                                        const nowCaz = getRolNameById(newRolId) === "CAZADOR";
                                                                        if (!nowCaz) { row.secretarioId = ""; row.cargadorId = ""; }

                                                                        const rolName = getRolNameById(newRolId);
                                                                        const per = personas.find((x) => Number(x.id) === Number(row.personaId));
                                                                        const okPersona =
                                                                            rolName === "CAZADOR"
                                                                                ? per?.tipoPersona === "CLIENTE"
                                                                                : rolName === "SECRETARIO" || rolName === "CARGADOR"
                                                                                    ? per?.tipoPersona === "STAFF"
                                                                                    : true;
                                                                        if (!okPersona) row.personaId = "";

                                                                        updated[cIdx].participaciones[pIdx] = row;
                                                                        setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                    }}
                                                                >
                                                                    <option value="">Seleccione</option>
                                                                    {roles.map((r) => (
                                                                        <option key={r.id} value={r.id}>{r.rol}</option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className={styles.partField}>
                                                                <div className={styles.partLabel}>Persona</div>
                                                                <select
                                                                    value={p.personaId}
                                                                    onChange={(e) => {
                                                                        const updated = [...form.cacerias];
                                                                        updated[cIdx].participaciones[pIdx].personaId = Number(e.target.value) || "";
                                                                        setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                    }}
                                                                >
                                                                    <option value="">Seleccione</option>
                                                                    {personasDisponibles.map((pers) => (
                                                                        <option key={pers.id} value={pers.id}>
                                                                            {pers.nombre} {pers.apellidos}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className={styles.partField}>
                                                                <div className={styles.partLabel}>Arma 1</div>
                                                                <div className={styles.armaField}>
                                                                    <ArmaSearchSelect armas={armasIndex} valueId={p.arma1Id || ""} onChange={(newId) => {
                                                                        const updated = [...form.cacerias];
                                                                        updated[cIdx].participaciones[pIdx].arma1Id = newId || "";
                                                                        setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                    }} />
                                                                </div>
                                                            </div>

                                                            <div className={styles.partField}>
                                                                <div className={styles.partLabel}>Arma 2</div>
                                                                <div className={styles.armaField}>
                                                                    <ArmaSearchSelect armas={armasIndex} valueId={p.arma2Id || ""} onChange={(newId) => {
                                                                        const updated = [...form.cacerias];
                                                                        updated[cIdx].participaciones[pIdx].arma2Id = newId || "";
                                                                        setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                    }} />
                                                                </div>
                                                            </div>

                                                            <div className={styles.partField}>
                                                                <div className={styles.partLabel}>Secretario</div>
                                                                {esCazador ? (
                                                                    <select
                                                                        value={p.secretarioId || ""}
                                                                        onChange={(e) => {
                                                                            const updated = [...form.cacerias];
                                                                            updated[cIdx].participaciones[pIdx].secretarioId = Number(e.target.value) || "";
                                                                            setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                        }}
                                                                    >
                                                                        <option value="">Selecciona secretario</option>
                                                                        {sortPersonasByNombre(personas.filter((per) => per.tipoPersona === "STAFF")).map((per) => (
                                                                            <option key={per.id} value={per.id}>
                                                                                {per.nickname ? per.nickname : `${per.nombre} ${per.apellidos}`}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <span className={styles.muted}>—</span>
                                                                )}
                                                            </div>

                                                            <div className={styles.partField}>
                                                                <div className={styles.partLabel}>Cargador</div>
                                                                {esCazador ? (
                                                                    <select
                                                                        value={p.cargadorId || ""}
                                                                        onChange={(e) => {
                                                                            const updated = [...form.cacerias];
                                                                            updated[cIdx].participaciones[pIdx].cargadorId = Number(e.target.value) || "";
                                                                            setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                        }}
                                                                    >
                                                                        <option value="">Selecciona cargador</option>
                                                                        {sortPersonasByNombre(personas.filter((per) => per.tipoPersona === "STAFF")).map((per) => (
                                                                            <option key={per.id} value={per.id}>
                                                                                {per.nickname ? per.nickname : `${per.nombre} ${per.apellidos}`}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <span className={styles.muted}>—</span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className={styles.partActions}>
                                                            <button
                                                                className={`${styles.btn} ${styles.danger}`}
                                                                type="button"
                                                                onClick={() => {
                                                                    const updated = [...form.cacerias];
                                                                    updated[cIdx].participaciones.splice(pIdx, 1);
                                                                    setForm((prev) => ({ ...prev, cacerias: updated }));
                                                                }}
                                                            >
                                                                Eliminar
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>

                                <div className={styles["item-actions"]}>
                                    <span className={styles.chip}>
                                        {(c.participaciones || []).length} participante(s)
                                    </span>

                                    <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                                        <button
                                            className={`${styles.btn} ${styles.primary}`}
                                            type="button"
                                            onClick={() => {
                                                const updated = [...form.cacerias];
                                                const rolCazadorId = roles.find((r) => r.rol === "CAZADOR")?.id || "";
                                                updated[cIdx].participaciones = updated[cIdx].participaciones || [];
                                                updated[cIdx].participaciones.push({
                                                    personaId: "",
                                                    rolId: rolCazadorId,
                                                    arma1Id: "",
                                                    arma2Id: "",
                                                });
                                                setForm((prev) => ({ ...prev, cacerias: updated }));
                                            }}
                                        >
                                            + Añadir
                                        </button>
                                        <button
                                            className={`${styles.btn} ${styles.secondary || styles.ghost}`}
                                            type="button"
                                            onClick={() => duplicateCaceria(cIdx)}
                                        >
                                            Duplicar cacería
                                        </button>

                                        <button
                                            className={`${styles.btn} ${styles.danger}`}
                                            type="button"
                                            onClick={() => removeItem("cacerias", cIdx)}
                                        >
                                            Eliminar cacería
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </Section>
    );
}
